export const RESERVED_SHOP_IDS = new Set([
  'auth',
  'login',
  'logout',
  'clientid',
  'api',
  '~',
  'socket.io',
  '__webpack_hmr'
])

export function isReservedShopId (shopId: string | undefined | null): boolean {
  return !!shopId && RESERVED_SHOP_IDS.has(shopId.toLowerCase())
}
